"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.defaultState = {
            amount: '',
            currency: {}
        };
        this.state = { ...this.defaultState };
        this.Currencies = GState.get('currencies');
        this.currencyOptions = Object.entries(this.Currencies).map(([countryId, currency]) => {
            return {
                label: `${ currency.name } - (${ currency.symbol || currency.id })`,
                value: countryId
            };
        });
    },
    onInput: function ({value}) {
        this.setState(value || this.defaultState);
    },
    onChange: function (name, value) {
        switch (name) {
        case 'amount':
            this.state.amount = Number(value.target.value);
            break;
        case 'currency':
            this.state.currency = {
                ...this.Currencies[value],
                countryId: value
            };
            break;
        }
        this.emit('change', this.state.toJSON());
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/PriceInput.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    Select_template = require("../../components/Select/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Select_tag = marko_loadTag(Select_template),
    marko_attrs0 = {
        "class": "input-group"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  out.e("input", {
      type: "number",
      value: state.amount,
      "class": marko_classValue(("form-control form-control-" + input.size) + " pl-4"),
      placeholder: input.placeholder || Locale("Price")
    }, "1", component, 0, 0, {
      onchange: __component.d("change", "onChange", false, [
          "amount"
        ])
    });

  Select_tag({
      size: input.size,
      value: state.currency.countryId,
      options: component.currencyOptions,
      style: "margin-left:-1px;border-radius:0 3px 3px 0;",
      placeholder: Locale("Currency - ($)")
    }, out, __component, "2", [
    [
      "select",
      "onChange",
      false,
      [
          "currency"
        ]
    ]
  ]);

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
